<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import PropertyAsyncSelect from "../../../../../../../../_shared/_modules/property-async-select"
  import type {
    CustomerFilterValue,
    FilterDisplayMode,
  } from "../../_shared/_logic/customers-table-contract"
  import {
    contactDataOptions,
    customerTypeOptions,
    roleOptions,
  } from "../../_shared/_logic/filters"

  const archiveScopeOptions = [
    { name: "Aktiv", value: "ACTIVE" },
    { name: "Archiviert", value: "ARCHIVED" },
    { name: "Alle", value: "ALL" },
  ]

  let {
    filters = $bindable(),
    filterMode,
    organizationId,
    onChange = () => {},
  }: {
    filters: CustomerFilterValue
    filterMode: FilterDisplayMode
    organizationId: string
    onChange?: () => void
  } = $props()
</script>

<div class="filter-bar form">
  <Input
    type="text"
    placeholder="Suche"
    bind:value={filters.query}
    brightBackground={true}
    tooltip="Volltextsuche über Ansprechpartner, Kontakt, Adresse und Notizen."
    {onChange}
  />
  {#if filterMode === "detailed"}
    <Input
      type="select"
      placeholder="Typ"
      bind:value={filters.customerType}
      options={customerTypeOptions}
      brightBackground={true}
      {onChange}
    />
    <Input
      type="select"
      placeholder="Kontaktdaten"
      bind:value={filters.contactData}
      options={contactDataOptions}
      brightBackground={true}
      tooltip="Filtert nach vorhandenen Kontaktwegen."
      {onChange}
    />
    <PropertyAsyncSelect
      id="customers-filter-property"
      {organizationId}
      placeholder="Liegenschaft"
      bind:value={filters.propertyId}
      brightBackground={true}
      disabled={!organizationId}
      {onChange}
    />
    <Input
      type="select"
      placeholder="Rolle in Liegenschaften"
      bind:value={filters.role}
      options={roleOptions}
      brightBackground={true}
      tooltip="Filtert nach Rollen, die auf Liegenschafts- oder Einheitenzuordnungen gespeichert sind."
      {onChange}
    />
    <Input
      type="select"
      placeholder="Archivstatus"
      bind:value={filters.archiveScope}
      options={archiveScopeOptions}
      brightBackground={true}
      tooltip="Zeigt aktive, archivierte oder alle Ansprechpartner."
      {onChange}
    />
  {/if}
</div>

<style lang="less">
  .filter-bar {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 0.65rem;
    align-items: end;
    margin: 0 0 1rem 0;

    :global(.input),
    :global(.select-input) {
      width: 100%;
    }
  }
</style>
